<template>
    <div class="bg-warning rounded p-3">
        <div v-show="$i18n.locale === 'ko'">
            <p class="fw-400 f-95 mb-0">안녕하세요,
                <b>{{ selected_vendor.company.company_name }} 기업의 첫 번째
                    평가신청자</b> 이십니다.</p>
            <p class="fw-400 f-95 my-3">
                평가신청을 계속하시면 자동으로 <b>"기업 평가 관리자"</b> 로 지정되며, 향후 "기업 일반 참여자"의 평가
                접근 승인/거부 요청 이메일을 받게되십니다.
            </p>
            <p class="fw-400 f-95 mb-0">
                만약 본인이 관리자 권한을 수행하기에 적절하지 않다고 판단되시는 경우, 평가신청을 중단하시고 관리자 역할에 적합한 담당자가 먼저 평가신청을 하도록 안내해 주시기 바랍니다.
            </p>
            <p class="fw-400 f-95 mb-0">
                계속 진행하시려면 "다음"을 클릭해 주세요.
            </p>
        </div>
        <div v-show="$i18n.locale === 'en'">
            <p class="fw-400 f-95 mb-0">Hello, you are <b>the first
                evaluator for {{ selected_vendor.company.company_name }}
                company</b>.</p>
            <p class="fw-400 f-95 my-3">
                Continuing with the evaluation will automatically designate
                you as the <b>"Company Evaluation Manager"</b>.
                You will receive emails to grant or deny Assessment
                Participation Access for "Company General Participants".
            </p>
            <p class="fw-400 f-95 mb-0">
                If you determine that you do not have this authority, please
                stop the registration step and request evaluation access
                from the responsible person. If you wish to continue, please
                click "Next".
            </p>
        </div>
        <div v-show="$i18n.locale === 'ca'">
            <p class="fw-400 f-95 mb-0">您好，您是{{
                    selected_vendor.company.company_name
                }}公司的第一位评估者。</p>
            <p class="fw-400 f-95 my-3">
                继续评估将自动将您指定为“公司评估经理”。您将有权为“公司一般参与者”授予或拒绝评估权限，并将收到访问请求的电子邮件。
            </p>
            <p class="fw-400 f-95 mb-0">
                如果您确定您没有此权限，请停止评估并向负责人请求评估权限。如果您希望继续，请点击“下一步”。
            </p>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'UnValidatedVendorCodeGuide',
    data() {
        return {
            loading: false,
        };
    },
    computed: {
        ...mapState('register',['selected_vendor'])
    },
    methods: {
    },
    mounted() {
    }
};
</script>

<style lang="scss" scoped>

</style>
